import request from 'sb-request'
import { getState, reducers } from 'redux/core'
import { ageCategoryEnum } from 'common/helpers/getters/getAgeCategoryFromBirthday/getAgeCategoryFromBirthday'

import voteFragranticaProductsMutation from './voteFragraticaProducts.graphql'


const { reset } = reducers.view.improveRecommendationsPage

const fetchSearch = (query) => {
  reducers.view.improveRecommendationsPage.setFetching(true)

  return request.get('rest/engine/fr_search', {
    query: {
      query: String(query),
    },
    modifyResult: ({ suggestions = [] }) => (
      suggestions.map(({ name, brand, value, data, img }) => ({
        name,
        brand,
        image: img,
        fullName: value,
        id: data,
      }))
    ),
  })
    .then((items) => reducers.view.improveRecommendationsPage.setSearchResults(items))
}

const resetSearch = () => {
  reducers.view.improveRecommendationsPage.setSearchResults([])
}

const rateItem = (item, status, ageCategory) => {
  const input = {
    votes: [
      { productId: item.id, status },
    ],
    ageCategory: ageCategoryEnum[ageCategory],
  }

  reducers.view.improveRecommendationsPage.saveItem({ item, status })

  return request.post('graphql?name=voteFragranticaProducts', {
    body: {
      query: voteFragranticaProductsMutation,
      variables: { input },
    },
  })
}

// When user set age category, we should save items again
const rerateWithAgeCategory = (ageCategory) => {
  if (!Boolean(ageCategory)) {
    return Promise.resolve()
  }

  const { view: { improveRecommendationsPage: { savedItems } } } = getState()

  const votes = Object.values(savedItems)
    .map((item) => ({
      productId: item.id,
      status: item.status,
    }))

  const input = {
    votes,
    ageCategory: ageCategoryEnum[ageCategory],
  }

  return request.post('graphql?name=voteFragranticaProducts', {
    body: {
      query: voteFragranticaProductsMutation,
      variables: { input },
    },
  })
}


export default {
  fetchSearch,
  resetSearch,
  rateItem,
  rerateWithAgeCategory,
  reset,
}
